import * as React from "react";
import { animationRegistry } from "@modules/animation";
export function ModelAnimationClips({ uid }) {
    const [, refresh] = React.useReducer((value) => value + 1, 0);
    React.useEffect(() => {
        const onChanged = () => {
            refresh();
        };
        animationRegistry.onChanged.add(onChanged);
        return () => {
            animationRegistry.onChanged.remove(onChanged);
        };
    }, [uid]);
    const targets = animationRegistry.getFacetTargets(uid);
    if (targets.length === 0)
        return null;
    return (React.createElement(React.Fragment, null, targets.map((target) => (React.createElement(AnimationClipRow, { key: target.uid, uid: target.uid, label: targets.length > 1 ? `Clip (${target.name})` : "Clip" })))));
}
function AnimationClipRow({ uid, label }) {
    var _a;
    const controls = animationRegistry.get(uid);
    if (!controls)
        return null;
    const hasSelection = controls.selectedAnimationClip !== null;
    return (React.createElement("tr", null,
        React.createElement("td", { className: "model-subtable-key" }, label),
        React.createElement("td", { className: "model-subtable-value" },
            React.createElement("div", { className: "model-animation-playback-controls" },
                React.createElement("select", { className: "facet-enum-select model-animation-clips", "aria-label": "Animation clip", title: "Preview animation clip (shared playback; does not change the saved default)", value: (_a = controls.selectedAnimationClip) !== null && _a !== void 0 ? _a : "", onChange: (event) => {
                        animationRegistry.selectClip(uid, Number(event.target.value));
                    } }, controls.animationClips.map((name, index) => (React.createElement("option", { key: index, value: index }, name || `Clip ${index + 1}`)))),
                React.createElement("div", { className: "model-animation-playback-buttons" },
                    React.createElement("button", { type: "button", disabled: !hasSelection, onClick: () => animationRegistry.command(uid, "play") }, "Play"),
                    React.createElement("button", { type: "button", disabled: !hasSelection, onClick: () => animationRegistry.command(uid, "pause") }, "Pause"),
                    React.createElement("button", { type: "button", title: "Return to the first frame and pause", disabled: !hasSelection, onClick: () => animationRegistry.command(uid, "reset") }, "Reset"))))));
}
